import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const FileContainer = styled.div`
  border: 1px solid #caced4;
  padding: 10px;
  display: flex;
  flex-direction: column;
  width: 200px;
  border-radius: 3px;
`;

const NameTitle = styled(TextLayoutComponent.Header)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ExtensionText = styled.span`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 14px;
  font-style: italic;
`;

const Link = styled.a`
  color: ${(props) => props.theme.color.primary};
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  align-self: center;
  padding-top: 10px;
`;

const LinkDelete = styled.a`
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  align-self: center;
  padding-top: 10px;
  color: ${(props) => props.theme.color.deleteLink};

  :hover {
    color: ${(props) => props.theme.color.deleteLinkHover};
  }

  :active {
    color: ${(props) => props.theme.color.deleteLinkActive};
  }
`;
const ContainerLinks = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export {
  FileContainer,
  NameTitle,
  ExtensionText,
  Link,
  LinkDelete,
  ContainerLinks,
};
